module.exports = __webpack_public_path__ + "static/media/Hospitalmang3-300.9a65ec4e.webp";